import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  // Request
  START_OR_CANCEL_IMPORT_PENDING: null,
  START_IMPORT_SUCCESS: null,
  CANCEL_IMPORT_SUCCESS: null,
  START_OR_CANCEL_IMPORT_ERROR: null,
  START_OR_CANCEL_RESET: null,
  // Progress
  FETCH_IMPORT_PROGRESS_PENDING: null,
  FETCH_IMPORT_PROGRESS_SUCCESS: null,
  FETCH_IMPORT_PROGRESS_ERROR: null
});